import { ForwardedRef, forwardRef, useState } from 'react';

import { Modal } from 'src/common/components';
import { ModalRefProps } from 'src/common/components/Modal';

import { usePhoneListContext } from '../context';

import { CampaignsList } from './CampaignsList';

export const PhoneCampaignModal = forwardRef(
  (props, ref: ForwardedRef<ModalRefProps>): JSX.Element => {
    const { state, actions } = usePhoneListContext();
    const { selectedPhones } = state;
    const { assignToCampaign } = actions;
    const [selectedCampaign, setSelectedCampaign] = useState<string | null>(null);

    const handleAssignCampaign = async (): Promise<void> => {
      await assignToCampaign(selectedPhones, selectedCampaign as string);
    };

    return (
      <Modal
        cancelText="Cancel"
        actionText="Accept"
        actionFunc={handleAssignCampaign}
        disabled={!selectedCampaign}
        ref={ref}
      >
        <div>
          <h3>Select a campaign</h3>
          <div className="text-xs text-gray-2.0 mt-2">
            {`Selected phones: ${selectedPhones.length}`}
          </div>
          <div className="px-2 mt-4">
            <CampaignsList onChange={setSelectedCampaign} defaultValue={selectedCampaign} />
          </div>
        </div>
      </Modal>
    );
  }
);
